import { Button, Stack } from '@mui/material'
import styled from 'styled-components'

export const Buttoncontainer = styled(Stack)`
  position: sticky;
  bottom: 0;
  background-color: white;
  border-bottom-left-radius: 10;
  border-bottom-right-radius: 10;
  z-index: 9;
`

export const ActionButton = styled(Button)``

export const SubmitButton = styled.input`
  background-color: ${(props) => props.color ?? '#2264e5'};
  color: #ffffff;
  border-radius: 6px;
  text-transform: capitalize;
  font-weight: 700;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  min-width: 170px;
  font-size: 15px;
  border: 0px;
  cursor: pointer;

  &:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    cursor: default;
  }
`
